const lunr = require('lunr');

if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

$(function () {
  let documents = require('./lunr_index.json');
  if (window.location.pathname.includes('/pomoc/')) {
    documents = require('./lunr_index_sl.json');
  }

  // console.log('doc ready')
  var idx = lunr(function () {
    this.ref('href')
    this.field('question', {
      boost: 10,
    })
    this.field('tags', {
      boost: 10,
    })
    this.field('answer')

    documents.forEach(function (doc) {
      this.add(doc)
    }, this)
  })

  var input = document.getElementById('search-input');
  const resultsList = $('#results');

  const helpSearchDocuments = {};

  documents.forEach(function(doc) {
    helpSearchDocuments[doc.href] = doc;
  });

  document.addEventListener("click", function(evt) {
    var targetElement = evt.target;  // clicked element

    do {
      if (targetElement === input && input.value) {
        // This is a click inside. Show results list and return.
        input.classList.add('results-visible');
        resultsList.show();
        return;
      }
      // Go up the DOM
      targetElement = targetElement.parentNode;
    } while (targetElement);

    // This is a click outside.
    input.classList.remove('results-visible');
    resultsList.hide()
  });

  input.addEventListener('input', function()
  {
    resultsList.empty();
    if (input.value) {
      const results = idx.query(function (query) {
        var wildcardAddingQuery = {
          clause: function(clause) {
            query.clause(Object.assign({}, clause, {
              wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING,
            }));
            query.clause(clause);
          }
        }

        var parser = new lunr.QueryParser(input.value, wildcardAddingQuery);
        parser.parse();
      });

      $.each(results, function(result) {
        const ref = results[result].ref;
        const doc = helpSearchDocuments[ref];
        var li = $('<li/>').appendTo(resultsList);
        $('<a href=' + ref + '/>').text(doc.question).appendTo(li);
      })
      if (!results.length) {
        input.classList.remove('results-visible');
        resultsList.hide();
      } else {
        input.classList.add('results-visible');
        resultsList.show();
      }
    } else {
      input.classList.remove('results-visible');
      resultsList.hide();
    }
  });
});
